<template lang="pug">
.sv-datepicker(
    v-click-outside="() => toggleCalendar(false)"
)
    input.sv-datepicker__input(
        v-model="date"
        type="text"
        :placeholder="placeholder"
        @input="changeDateText"
        @focus="toggleCalendar(true)"
    )

    SvCalendar.sv-datepicker__calendar(
        v-show="isOpenCalendar"
        @input="changeDate"
    )

    SvIcon.sv-datepicker__icon(
        icon="grid"
        :width="16"
        :height="16"
    )
</template>

<script>
import vClickOutside from 'v-click-outside';
import SvIcon from '@/components/uikit/SvIcon.vue';
import SvCalendar from '@/components/uikit/SvCalendar.vue';

export default {
  name: 'SvDatePicker',

  directives: {
    clickOutside: vClickOutside.directive,
  },

  data() {
    return {
      date: '',
      isOpenCalendar: false,
    };
  },

  props: {
    value: {
      type: String,
      default: '',
    },

    placeholder: {
      type: String,
      default: 'Укажите дату',
    },
  },

  watch: {
    value: {
      handler (val) {
        this.date = val;
      },
      immediate: true
    }
  },

  components: {
    SvCalendar,
    SvIcon,
  },

  methods: {
    toggleCalendar(val) {
      this.isOpenCalendar = val;
    },

    changeDateText () {
      this.$emit('input', this.date);
    },

    changeDate({ year, month, day }) {
      this.date = `${+day > 9 ? '' : 0}${day}.${+month > 9 ? '' : 0}${month}.${year}`;
      this.toggleCalendar(false);
      this.$emit('input', this.date);
    },
  },
};
</script>

<style lang="scss" scoped>
.sv-datepicker {
    position: relative;
    width: 310px;

    &__input {
        width: 310px;
        border: 0;
        outline: none;
        height: 40px;
        background: #F3F3F6;
        border-radius: 5px;
        padding-left: 21px;
        font-size: 14px;
        color: #404450;
        width: 100%;
        cursor: pointer;

        &::placeholder {
            color: #ADB2C0;
        }
    }

    &__calendar {
        position: absolute;
        top: 40px;
        z-index: 99;
    }

    &__icon {
        position: absolute;
        top: 12px;
        right: 20px;
    }
}
</style>
